import React, { useEffect,useState } from 'react'

import Toast from '../components/Toast'

interface ToastProps {
  toast: React.Dispatch<React.SetStateAction<string | null>>
}

function withToast<P>(WrappedComponent: React.ComponentType<P & ToastProps>) {
  const ComponentWithToast = (props: P) => {
    const [toast, setToast] = useState<string | null>(null)

    useEffect(() => {
      if (toast) {
        const timeout = setTimeout(() => setToast(null), 5000)
        return () => clearTimeout(timeout)
      }
    }, [toast])

    return (
      <>
        {toast && <Toast>{toast}</Toast>}
        <WrappedComponent {...props} toast={setToast} />
      </>
    )
  }

  return ComponentWithToast
}

export default withToast
